import { render, staticRenderFns } from "./clientMamage.vue?vue&type=template&id=24b6d99d&scoped=true&"
import script from "./clientMamage.vue?vue&type=script&lang=js&"
export * from "./clientMamage.vue?vue&type=script&lang=js&"
import style0 from "./clientMamage.vue?vue&type=style&index=0&id=24b6d99d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b6d99d",
  null
  
)

component.options.__file = "clientMamage.vue"
export default component.exports